import React from "react";
import { Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const GameMarqueeIconButton = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="solid"
      colorScheme="yellow"
      size="sm"
      minW="40px"
      minH="30px"
      fontSize="xs"
      opacity="0.3"
      _hover={{ opacity: 1 }}
      onClick={onClick}
    >
      {t("common.遊戲公告")}
    </Button>
  );
};

export default GameMarqueeIconButton;
